import React from 'react'
import { Skeleton } from 'primereact/skeleton';
const Loading = () => {
  return (
    <div className='loader'>
        <div className="row" style={{marginBottom:"10px"}}>
        <Skeleton width="8rem" height="3rem" className="mr-2"></Skeleton>
        <Skeleton width="8rem" height="3rem" className="mr-2"></Skeleton>
        <Skeleton width="8rem" height="3rem" className="mr-2"></Skeleton>
        <Skeleton width="8rem" height="3rem" className="mr-2"></Skeleton>
        <Skeleton width="8rem" height="3rem" className="mr-2"></Skeleton>
        </div>
        <div className="row" style={{marginBottom:"10px"}}>
        <Skeleton width="8rem" height="3rem" className="mr-2"></Skeleton>
        <Skeleton width="8rem" height="3rem" className="mr-2"></Skeleton>
        <Skeleton width="8rem" height="3rem" className="mr-2"></Skeleton>
        <Skeleton width="8rem" height="3rem" className="mr-2"></Skeleton>
        <Skeleton width="8rem" height="3rem" className="mr-2"></Skeleton>
        </div>
        <div className="row" style={{marginBottom:"10px"}}>
        <Skeleton width="8rem" height="3rem" className="mr-2"></Skeleton>
        <Skeleton width="8rem" height="3rem" className="mr-2"></Skeleton>
        <Skeleton width="8rem" height="3rem" className="mr-2"></Skeleton>
        <Skeleton width="8rem" height="3rem" className="mr-2"></Skeleton>
        <Skeleton width="8rem" height="3rem" className="mr-2"></Skeleton>
        </div>
        
      
    </div>
  )
}

export default Loading
